import ReactOnRails from 'react-on-rails'

import SessionsNew from 'bundles/sessions/new'

ReactOnRails.register({
  SessionsNew
})
